module.exports = __webpack_public_path__ + "img/map.77be94da.svg";